import { DataService } from "../Services/dataService";
import { FirebaseService } from "../Services/firebaseService";

export class ProfilPage {

    oldPasswordElement: HTMLInputElement = document.getElementById('oldPassword') as HTMLInputElement;
    passwordElement: HTMLInputElement = document.getElementById('password') as HTMLInputElement;
    passwordConfirmElement: HTMLInputElement = document.getElementById('passwordConfirm') as HTMLInputElement;
    submitElement: HTMLButtonElement = document.getElementById('changePassword') as HTMLButtonElement;
    successElement: HTMLElement = document.getElementById('success') as HTMLElement;
    unsubscribeElement: HTMLElement = document.getElementById('unsubscribe') as HTMLElement;

        loaderElement: HTMLElement = document.querySelector('.loader') as HTMLElement;


    firebaseService: FirebaseService
    dataService: DataService;
    constructor() {
        this.firebaseService = new FirebaseService();
        this.dataService = new DataService();
        this.init()
    }

    async init() {
        this.submitElement.addEventListener('click', (event: any) => {
            event.preventDefault();
            event.stopPropagation();
            this.changePassword();
        })
        this.unsubscribeElement.addEventListener('click', (event: any) => {
            event.preventDefault();
            event.stopPropagation();
            this.unsubscribe();
        })

        let user = await this.dataService.getUser(await this.firebaseService.getUserEmail(), await this.firebaseService.getUserIdToken());
        this.unsubscribeElement.style.display = "none";
        if (user.subscriptionStatus == "subscribed") {
            this.unsubscribeElement.style.display = "block";
        }
        else {
            this.unsubscribeElement.style.display = "none";
        }
    }

    async unsubscribe() {
        if (confirm("Etes-vous sûr de vouloir vous désabonner ?")) {
            this.loader(true);
            let token = await this.firebaseService.getUserIdToken();
            let email = await this.firebaseService.getUserEmail();
            if (token && email) {
                let r = await this.dataService.unsubscribeUser(token, email);
                alert(r.message);
                location.reload();
            }
            this.loader(false);
        }
    }

    async changePassword() {
        this.loader(true);
        if (this.passwordElement.value != this.passwordConfirmElement.value) {
            this.successElement.innerHTML = "Les mots de passe ne correspondent pas !";
        }
        else {
            let r = await this.firebaseService.changePassword(this.oldPasswordElement.value, this.passwordElement.value);
            if (r)
                this.successElement.innerHTML = "Mot de passe changé avec succès !";
            else
                this.successElement.innerHTML = "Impossible de changer votre mot de passe !";
        }
        this.loader(false);
    }

    
    loader(show: boolean) {
        this.loaderElement.style.display = show ? 'block' : 'none';
    }
}